import chips from '../../../../../content/lang/chips.json';

export function QuickChips({ bridge }) {
    return (<div class="chip-tray" role="group" aria-label="Quick chat" onPointerDown={(e) => e.stopPropagation()}>
      {chips.map((c) => (<button key={c.id} type="button" class="chip" data-chip={c.id} title={c.gloss} lang={c.igbo ? 'ig' : undefined} onClick={() => bridge.chip(c.id)}>{c.text}</button>))}
    </div>);
}
